import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/utils/cn'

const STATUS_COLORS: Record<string, string> = {
  draft: 'bg-muted text-muted-foreground border-border',
  active: 'bg-success/15 text-success border-success/30',
  closed: 'bg-muted text-muted-foreground border-border',
  archived: 'bg-warning/15 text-warning border-warning/30',
}

export function CaseStatusBadge({ status }: { status: string }) {
  const { t } = useTranslation()
  return (
    <Badge variant="outline" className={cn('text-xs', STATUS_COLORS[status])}>
      {t(`cases.status.${status}`)}
    </Badge>
  )
}
